import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { getCurrentUser } from "@/lib/supabaseClient";

export default function ProtectedAdminRoute({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    getCurrentUser().then(setUser);
  }, []);

  if (user === undefined) {
    return (
      <div className="min-h-screen bg-[#0B1220] flex items-center justify-center">
        <div className="w-12 h-12 border-2 border-[#38BDF8] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
